import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Container, Spinner, Alert } from 'react-bootstrap';
import { GET_PAGE } from '../graphql/pages';
import Layout from '../components/Layout';

const Page: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  const { data, loading, error } = useQuery(GET_PAGE, {
    variables: { slug },
    skip: !slug,
  });

  if (loading) {
    return (
      <Layout showSidebar={false}>
        <Container className="py-5" style={{ maxWidth: '56rem' }}>
          <div className="text-center py-5">
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </Container>
      </Layout>
    );
  }

  if (error || !data?.pageBySlug) {
    return (
      <Layout showSidebar={false}>
        <Container className="py-5 text-center" style={{ maxWidth: '56rem' }}>
          <Alert variant="danger">
            <Alert.Heading as="h1" className="display-6 fw-bold mb-3">Page Not Found</Alert.Heading>
            <p className="mb-0">The page you're looking for doesn't exist.</p>
          </Alert>
        </Container>
      </Layout>
    );
  }

  const page = data.pageBySlug;

  return (
    <Layout showSidebar={false}>
      <Container className="py-5" style={{ maxWidth: '56rem' }}>
        {/* Page Header */}
        <div className="mb-4">
          <h1 className="display-4 fw-bold mb-2">{page.title}</h1>
          {page.subtitle && (
            <p className="fs-4 text-muted">{page.subtitle}</p>
          )}
        </div>

        {/* Page Content */}
        <div
          className="page-content text-secondary"
          dangerouslySetInnerHTML={{ __html: page.content }}
          style={{
            fontSize: '1.125rem',
            lineHeight: '1.75',
          }}
        />

        {/* Last Updated */}
        <div className="mt-5 pt-4 border-top text-muted small">
          Last updated: {new Date(page.updatedAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
        </div>
      </Container>
    </Layout>
  );
};

export default Page;
